module.exports = __webpack_public_path__ + "static/media/start-onboarding.249e1742.png";